import { render, staticRenderFns } from "./Limos_list.vue?vue&type=template&id=4b012d58&scoped=true&"
import script from "./Limos_list.vue?vue&type=script&lang=js&"
export * from "./Limos_list.vue?vue&type=script&lang=js&"
import style0 from "./Limos_list.vue?vue&type=style&index=0&id=4b012d58&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b012d58",
  null
  
)

export default component.exports